import {createVuetify, IconOptions, ThemeDefinition} from 'vuetify';
import {aliases} from 'vuetify/iconsets/mdi';
import {de, en} from 'vuetify/locale';
import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import {mdiSvgIconSet} from './mdi-svg-iconset';

// Modern, clean design system. Deep-teal brand (the app-wide default; per-tenant
// branding still overrides `--primary` at runtime), coral accent, calm light
// surfaces, soft diffuse shadows and rounded geometry. The visual polish lives
// in assets/scss/modern.scss; this file owns the palette and component shapes.
const communityTheme: ThemeDefinition = {
    dark: false,
    colors: {
        background: '#f7f9fc',
        surface: '#ffffff',
        'surface-bright': '#ffffff',
        'surface-variant': '#f1f5f9',
        'on-surface-variant': '#667085',
        primary: '#114B5F',
        'primary-darken-1': '#0E3A49',
        secondary: '#0E3A49',
        accent: '#f97066',
        error: '#e5484d',
        info: '#0e9cd4',
        success: '#15b097',
        warning: '#f5a524',
        'on-background': '#475467',
        'on-surface': '#1e293b',
        'on-primary': '#ffffff',
        'on-secondary': '#ffffff',
        'on-accent': '#ffffff',
    },
    variables: {
        'medium-emphasis-opacity': 0.68,
        'high-emphasis-opacity': 0.92,
    },
};

export const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light',
        themes: {
            // Override the built-in light theme so existing `.v-theme--light`
            // style overrides keep applying on top of the new palette.
            light: communityTheme,
        },
    },
    defaults: {
        VBtn: {
            class: 'text-none',
        },
        VChip: {
            rounded: 'pill',
        },
        VCard: {
            variant: 'flat',
        },
        VTextField: {
            variant: 'outlined',
            rounded: 'lg',
        },
        VTextarea: {
            variant: 'outlined',
            rounded: 'lg',
        },
        VSelect: {
            variant: 'outlined',
            rounded: 'lg',
        },
        VCombobox: {
            variant: 'outlined',
            rounded: 'lg',
        },
        VAutocomplete: {
            variant: 'outlined',
            rounded: 'lg',
        },
        VAlert: {
            rounded: 'lg',
        },
    },
    icons: <IconOptions>{
        defaultSet: 'mdi',
        aliases,
        sets: {mdi: mdiSvgIconSet},
    },
    locale: {
        locale: 'de',
        fallback: 'de',
        messages: {de, en},
    },
});
